export enum EnumPlans {
  free = 'free',
  essential = 'essential',
  professional = 'professional',
  enterpriseplus = 'enterpriseplus',
  // Legacy plans below
  trial = 'trial',
  solo = 'solo',
  starter = 'starter',
  business = 'business',
  pro = 'pro',
  enterprise = 'enterprise',
  partner = 'partner',
}

export enum EnumPaymentTypes {
  card = 'card',
  invoice = 'invoice',
}

export enum EnumPaymentFrequency {
  monthly = 'monthly',
  annual = 'annual',
}
